function initChatWidgetDraggable() {
  $(".js-chat_widget__container").draggable({
    handle: ".js-chat_widget__header",
    containment: "window"
  });
}

// 最新メッセージまでスクロール
function scrollToBottom(chatBody) {
  if (chatBody) {
    setTimeout(() => {
      chatBody.scrollTop = chatBody.scrollHeight;
    }, 100);
  }
}

function isMobile() {
  return window.innerWidth <= 480;
}

function updateDisplayForDevice(closeMobileButton) {
  if (!closeMobileButton) return;
  if (isMobile()) {
    closeMobileButton.classList.remove('hidden');
  } else {
    closeMobileButton.classList.add('hidden');
  }
}

function initChatWidget() {
  const chatWidget = document.querySelector('.js-chat_widget');
  if (!chatWidget) return;

  const openButton = document.querySelector('.js-chat_widget__button-open');
  const closeButton = document.querySelector('.js-chat_widget__button-close');
  const closeMobileButton = document.querySelector('.js-close-button-mobile');
  const container = document.querySelector('.js-chat_widget__container');
  const textForm = document.querySelector('.js-chat_widget__form-text');
  const imageForm = document.querySelector('.js-chat_widget__form-image');
  const textarea = textForm?.querySelector('.js-chat-textarea');
  const chatBody = document.querySelector('.js-chat_widget__body');
  const expandButton = document.querySelector('.js-expand-button');
  const helpButton = document.querySelector('.js-help-button');
  const clipButton = textForm?.querySelector('.js-clip-button');
  const sendButton = textForm?.querySelector('.js-send-button');
  const helpTextDefault = document.querySelector('.js-help-text-default');
  const helpTextInput = document.querySelector('.js-help-text-input');
  const recipientTypeField = textForm?.querySelector('.js-recipient-type-field');
  const recipientTypeFieldImage = imageForm?.querySelector('.js-recipient-type-field-image');
  const textErrorBox = document.querySelector('.js-chat_widget__form-error');

  updateDisplayForDevice(closeMobileButton);
  window.addEventListener('resize', () => updateDisplayForDevice(closeMobileButton));

  openButton.addEventListener('click', () => {
    container.classList.remove('hidden');
    openButton.classList.add('hidden');
    if (!isMobile()) {
      closeButton.classList.remove('hidden');
    }
    const unreadBadge = document.querySelector('.js-chat-widget-unread-badge');
    if (unreadBadge) unreadBadge.style.display = 'none';
    $.ajax({
      url: '/chat_messages/mark_as_reads',
      type: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name=csrf-token]').attr('content'),
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    scrollToBottom(chatBody);
  });

  closeButton.addEventListener('click', () => {
    container.classList.add('hidden');
    openButton.classList.remove('hidden');
    closeButton.classList.add('hidden');
  });

  if (closeMobileButton) {
    closeMobileButton.addEventListener('click', () => {
      container.classList.add('hidden');
      openButton.classList.remove('hidden');
    });
  }

  if (helpButton) {
    helpButton.addEventListener('click', function() {
      window.open('/', '_blank');
    });
  }

  const aiButton = document.querySelector('.js-ai-chat-tab');
  const tutorButton = document.querySelector('.js-tutor-chat-tab');
  const topContent = document.querySelector('.js-p-chat_widget__top-content');
  const aiMessages = document.querySelector('.js-p-chat_widget__ai-messages');
  const tutorMessages = document.querySelector('.js-p-chat_widget__tutor-messages');
  const aiAvatar = document.querySelector('.js-chat_widget__header-left-avatar-ai');
  const tutorAvatar = document.querySelector('.js-chat_widget__header-left-avatar-tutor');
  const onboardingMessages = document.querySelector('.js-onboarding-messages');

  if (aiButton && tutorButton) {
    aiButton.addEventListener('click', function() {
      // switchToAiChatForm equivalent (inline)
      aiButton.classList.add('active');
      tutorButton.classList.remove('active');
      if (aiAvatar && tutorAvatar) {
        aiAvatar.classList.remove('hidden');
        tutorAvatar.classList.add('hidden');
      }
      if (topContent) {
        const aiContent = document.querySelector('.js-p-chat_widget__ai-content');
        const tutorContent = document.querySelector('.js-p-chat_widget__tutor-content');
        if (aiContent && tutorContent) {
          aiContent.classList.add('active');
          aiContent.classList.remove('hidden');
          tutorContent.classList.add('hidden');
          tutorContent.classList.remove('active');
        }
      }
      if (aiMessages && tutorMessages) {
        aiMessages.classList.add('active');
        aiMessages.classList.remove('hidden');
        tutorMessages.classList.add('hidden');
        tutorMessages.classList.remove('active');
      }
      if (onboardingMessages) onboardingMessages.classList.remove('hidden');
      if (recipientTypeField) recipientTypeField.value = 'ai';
      if (recipientTypeFieldImage) recipientTypeFieldImage.value = 'ai';
      scrollToBottom(chatBody);
    });

    tutorButton.addEventListener('click', function() {
      tutorButton.classList.add('active');
      aiButton.classList.remove('active');
      if (aiAvatar && tutorAvatar) {
        aiAvatar.classList.add('hidden');
        tutorAvatar.classList.remove('hidden');
      }
      if (topContent) {
        const aiContent = document.querySelector('.js-p-chat_widget__ai-content');
        const tutorContent = document.querySelector('.js-p-chat_widget__tutor-content');
        if (aiContent && tutorContent) {
          tutorContent.classList.add('active');
          tutorContent.classList.remove('hidden');
          aiContent.classList.add('hidden');
          aiContent.classList.remove('active');
        }
      }
      if (aiMessages && tutorMessages) {
        tutorMessages.classList.add('active');
        tutorMessages.classList.remove('hidden');
        aiMessages.classList.add('hidden');
        aiMessages.classList.remove('active');
      }
      if (onboardingMessages) onboardingMessages.classList.add('hidden');
      if (recipientTypeField) recipientTypeField.value = 'tutor';
      if (recipientTypeFieldImage) recipientTypeFieldImage.value = 'tutor';
      scrollToBottom(chatBody);
    });
  }

  if (expandButton) {
    expandButton.addEventListener('click', () => {
      const chatWidgetContainer = document.querySelector('.js-chat_widget__container');
      const expandIcon = expandButton.querySelector('.js-expand-icon');
      const expandCloseIcon = expandButton.querySelector('.js-expand-close-icon');
      if (expandIcon && expandCloseIcon) {
        if (expandIcon.classList.contains('hidden')) {
          expandIcon.classList.remove('hidden');
          expandCloseIcon.classList.add('hidden');
          if (chatWidgetContainer) chatWidgetContainer.classList.remove('expanded');
        } else {
          expandIcon.classList.add('hidden');
          expandCloseIcon.classList.remove('hidden');
          if (chatWidgetContainer) chatWidgetContainer.classList.add('expanded');
        }
      }
    });
  }

  // テキスト/画像/モーダル 初期化
  if (typeof initPublicTextForm === 'function') initPublicTextForm();
  if (typeof initChatImageUploader === 'function') initChatImageUploader();
  if (typeof initImageModal === 'function') initImageModal();

  // 初期表示で最新へスクロール
  scrollToBottom(chatBody);
}

window.initChatWidget = initChatWidget;
window.initChatWidgetDraggable = initChatWidgetDraggable;